/* eslint-disable react-hooks/exhaustive-deps */
import { Descriptions, DatePicker, Typography } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

import { showErrorNotification, showSuccessNotification } from "../../utils/notification";
import { clamp } from "../../utils/responsiveHelpers";
import AnalyticsGenericBarGraph from "../common-utils/GenericBarGraph";

const AdminDashboard = ({ ROOT_URL }) => {
  const currentDate = new Date();
  const twoMonthsAgo = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() - 2,
    currentDate.getDate()
  );

  const [filter, setFilter] = useState({
    startDate: twoMonthsAgo,
    endDate: currentDate
  });
  const [userGraphStats, setUserGraphStats] = useState([]);
  const [paidUsersGraphStats, setPaidUsersGraphStats] = useState([]);
  const [dailyActiveUserStats, setDailyActiveUserStats] = useState([]);
  const [cumulativeUserGrowthBarPoints, setCumulativeUserGrowthBarPoints] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalPaidUserCount, setTotalPaidUserCount] = useState(0);

  const fetchUserSignUpStats = () => {
    axios
      .get(`${ROOT_URL}/admin/dashboard/user-stats`, {
        params: {
          filter
        }
      })
      .then((res) => {
        const { userRegistrationStats, totalUsersCount } = res.data;
        setUserGraphStats(userRegistrationStats);
        setTotalUsers(totalUsersCount);
        showSuccessNotification("User Stats Fetched Successfully");
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const fetchPaidConvertedUserStats = () => {
    axios
      .get(`${ROOT_URL}/admin/dashboard/converted-user-stats`, {
        params: {
          filter
        }
      })
      .then((res) => {
        const { paidUsersCountByCreationDate, totalPaidUserCount } = res.data;
        setPaidUsersGraphStats(paidUsersCountByCreationDate);
        setTotalPaidUserCount(totalPaidUserCount);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const fetchDailyActiveUserStats = () => {
    axios
      .get(`${ROOT_URL}/admin/dashboard/daily-active-user-stats`, {
        params: {
          filter
        }
      })
      .then((res) => {
        const { dayWiseActiveUserCountMap } = res.data;
        setDailyActiveUserStats(dayWiseActiveUserCountMap);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const fetchCumulativeUserGrowthStats = () => {
    axios
      .get(`${ROOT_URL}/admin/dashboard/cumulative-user-growth`, {
        params: {
          filter
        }
      })
      .then((res) => {
        const { cumulativeUserRegistrationStats } = res.data;
        setCumulativeUserGrowthBarPoints(cumulativeUserRegistrationStats);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  useEffect(() => {
    fetchUserSignUpStats();
    fetchPaidConvertedUserStats();
    fetchDailyActiveUserStats();
    fetchCumulativeUserGrowthStats();
  }, [filter]);

  return (
    <div
      style={{
        marginTop: "20px",
        marginLeft: clamp(12, 30),
        marginRight: clamp(12, 30)
      }}
    >
      <Typography>Default Filter is of 2 months</Typography>
      <DatePicker.RangePicker
        style={{ width: "50%" }}
        value={
          filter.startDate && filter.endDate ? [dayjs(filter.startDate), dayjs(filter.endDate)] : []
        }
        onChange={(dates) => {
          if (dates) {
            setFilter((prevFilter) => ({
              ...prevFilter,
              startDate: dates[0].clone().startOf("day").toDate(),
              endDate: dates[1].clone().endOf("day").toDate()
            }));
          } else {
            setFilter((prevFilter) => ({
              ...prevFilter,
              startDate: null,
              endDate: null
            }));
          }
        }}
      />
      <div
        style={{
          borderWidth: "1px",
          borderColor: "black"
        }}
      >
        <Descriptions title="User Stats" bordered>
          <Descriptions.Item label="Total New Users">{totalUsers}</Descriptions.Item>
        </Descriptions>
        <div
          style={{
            marginTop: "20px",
            borderWidth: "1px",
            borderColor: "black"
          }}
        >
          <AnalyticsGenericBarGraph dataPoints={userGraphStats} yAxisFieldName="count" />
        </div>
      </div>
      <div
        style={{
          borderWidth: "1px",
          borderColor: "black",
          marginTop: "20px"
        }}
      >
        <Descriptions title="Converted User Stats" bordered>
          <Descriptions.Item label="Total converted users">{totalPaidUserCount}</Descriptions.Item>
        </Descriptions>
        <div
          style={{
            marginTop: "20px",
            borderWidth: "1px",
            borderColor: "black"
          }}
        >
          <AnalyticsGenericBarGraph dataPoints={paidUsersGraphStats} yAxisFieldName="count" />
        </div>
      </div>
      <div
        style={{
          borderWidth: "1px",
          borderColor: "black",
          marginTop: "20px"
        }}
      >
        <Descriptions title="Daily Active Users" bordered />
        <div
          style={{
            marginTop: "20px",
            borderWidth: "1px",
            borderColor: "black"
          }}
        >
          <AnalyticsGenericBarGraph dataPoints={dailyActiveUserStats} yAxisFieldName="count" />
        </div>
      </div>
      <div
        style={{
          marginTop: "20px",
          borderWidth: "1px",
          borderColor: "black"
        }}
      >
        <Descriptions title="Cumulative User Growth" bordered />
        <div
          style={{
            marginTop: "20px",
            borderWidth: "1px",
            borderColor: "black"
          }}
        >
          <AnalyticsGenericBarGraph
            dataPoints={cumulativeUserGrowthBarPoints}
            yAxisFieldName="count"
          />
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
